import NextHead from '@/components/NextHead';
import metas from '@/routes/meta';
import { FlexCol, Image, bffService } from '@thisisdevelopment/akzonobel-core';
import {
  Page,
  ProductCard,
  getArgsProductImpressions,
} from '@thisisdevelopment/heritage-core-library';
import { GetStaticProps } from 'next';
import { FC, useEffect } from 'react';
import { PageUnavailable } from '@/components/PageUnavailable';
import { pageRevalidate } from '../../../src/config';
import { OurProductsType } from './index';
import { sendGTMEvent } from '@next/third-parties/google';

type SSRProps = {
  page: OurProductsType | null;
  products: any;
  image: any;
};

const Products: FC<SSRProps> = ({ products, image, page }) => {
  useEffect(() => {
    if (products && products.length > 0) {
      sendGTMEvent(getArgsProductImpressions(products));
    }
  }, [products]);

  const meta = metas.products;

  if (!page) return <PageUnavailable />;

  return (
    <div style={{ overflow: 'auto' }}>
      <NextHead meta={meta} />
      <Page title={page.title} headline={page.headline}>
        <FlexCol gap={'40px'} mb={'60px'}>
          {products.map((product: any) => (
            <ProductCard key={product.globalId} product={product}>
              {image && (
                <Image
                  src={image.data.full_url}
                  width={image.width}
                  height={image.height}
                  alt={`Product Image ${product.globalId}`}
                />
              )}
            </ProductCard>
          ))}
        </FlexCol>
      </Page>
    </div>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  const products = await bffService
    .getProducts()
    .then((res) => res.data.products)
    .catch(() => []);
  const page = await bffService
    .getCmsItem('our_products')
    .then((res) => res.data.data[0])
    .catch(() => null);

  if (!page) {
    return { notFound: true };
  }

  const image = page.product_list_background
    ? await bffService
        .getCmsFile(page.product_list_background)
        .then((res) => res.data.data)
        .catch(() => null)
    : null;

  return {
    props: { page, products, image },
    revalidate: pageRevalidate,
  };
};

export default Products;
